import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Video from 'twilio-video';
import '../../css/SingleScreens/ConsultationScreen.css';

import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, VideoCallActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class VideoCallScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
        token: '',
        identity: null,  /* Will hold the fake name assigned to the client. The name is generated by faker on the server */
        roomName: '',    /* Will store the room name */
        roomNameErr: false,  /* Track error for room name TextField. This will    enable us to show an error message when this variable is true */
        previewTracks: null,
        localMediaAvailable: false, /* Represents the availability of a LocalAudioTrack(microphone) and a LocalVideoTrack(camera) */
        hasJoinedRoom: false,
        activeRoom: null // Track the current active room
     };
  }

  componentDidMount() {
    const consultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    const consultationID = consultation._id;

    if (consultationID) {
      this.props.videoCallActions.getVideoCallToken(this.props.user.auth.token, consultationID, this.setTokenAndIdentity);
      this.setState({ ...this.state, roomName: consultationID });
    }
  }

  joinRoom = () => {

    if (!this.state.roomName.trim()) {
        this.setState({ roomNameErr: true });
        return;
    }

    console.log("Joining room '" + this.state.roomName + "'...");

    let connectOptions = {
        name: this.state.roomName,
    };

    if (this.state.previewTracks) {
        connectOptions.tracks = this.state.previewTracks;
    }

    //Connect to a room by providing the token and connection
    //options that include the room name and tracks. We also show
    //an alert if an error occurs while connecting to the room.

    Video.connect(this.state.token, connectOptions).then(this.roomJoined, error => {
        alert('Could not connect to Twilio: ' + error.message);
    });
  }

  roomJoined = (room) => {
    console.log("room: ", room);
    // Called when a participant joins a room
    console.log("Joined as '" + this.state.identity + "'");

    // Room name

    this.setState({
      activeRoom: room,
      localMediaAvailable: true,
      hasJoinedRoom: true  // Removes ‘Join Room’ button and shows ‘Leave Room’
    });

    // Attach LocalParticipant's tracks to the DOM, if not already attached.
    var previewContainer = this.refs.localMedia;
    if (!previewContainer.querySelector('video')) {
      this.attachParticipantTracks(room.localParticipant, previewContainer);
    }

    // // ... existing code
    // if (!previewContainer.querySelector('video')) {
    //   this.attachParticipantTracks(room.localParticipant, previewContainer);
    // }
    //
    // Attach the Tracks of the room's participants.
    room.participants.forEach(participant => {
      var remoteContainer = this.refs.remoteMedia;
      console.log("ALREADY IN ROOM")

      participant.tracks.forEach(publication => {
        if (publication.isSubscribed) {
          const track = publication.track;
          remoteContainer.appendChild(track.attach());
        }
      });

      participant.on('trackSubscribed', function (track) {
        remoteContainer.appendChild(track.attach());
      });

      // this.attachParticipantTracks(participant, previewContainer);
    });
    //
    // Participant joining room
    room.on('participantConnected', participant => {
      console.log("Joining: '" + participant.identity + "'");
    });
    //
    // Attach participant’s tracks to DOM when they add a track
    room.on('trackAdded', (track, participant) => {
      console.log(participant.identity + ' added track: ' + track.kind);
      var previewContainer = this.refs.remoteMedia;
      this.attachTracks([track], previewContainer);
    });
    //
    // // Detach participant’s track from DOM when they remove a track.
    room.on('trackRemoved', (track, participant) => {
      this.log(participant.identity + ' removed track: ' + track.kind);
      this.detachTracks([track]);
    });
    //
    // // Detach all participant’s track when they leave a room.
    room.on('participantDisconnected', participant => {
      console.log("Participant '" + participant.identity + "' left the room");
      this.detachParticipantTracks(participant);
    });

    // // Once the local participant leaves the room, detach the Tracks
    // // of all other participants, including that of the LocalParticipant.
    room.on('disconnected', () => {
      if (this.state.previewTracks) {
        this.state.previewTracks.forEach(track => {
          track.stop();
        });
      }
      this.detachParticipantTracks(room.localParticipant);
      room.participants.forEach(this.detachParticipantTracks);
      this.state.activeRoom = null;
      this.setState({ hasJoinedRoom: false, localMediaAvailable: false });
    });
  }

  renderVideoCallSection = () => {

    const showLocalTrack = this.state.localMediaAvailable ? <div><div ref="localMedia" /></div> : '';

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">


          <input  type='submit'
                  value='Join'
                  className='button-default'
                  onClick={ () => { this.joinRoom() }}
                />

          <input  type='submit'
                  value='Leave Room'
                  className='button-clear-blue'
                  onClick={ () => { this.leaveRoom() }}
                />

            { showLocalTrack }

            <div id="remote-media" ref="remoteMedia"  />
            <div ref={(node) => { this.container = node; }}></div>

      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          practice={this.props.practice.practice}
          userActions={this.props.userActions}
        />
        <SingleScreenNavBar title="Video Call" />
        { this.renderVideoCallSection() }
      </div>
    );
  }

  setTokenAndIdentity = (twilioToken, identity) => {
    if (twilioToken && identity) {
      this.setState({ ...this.state, token: twilioToken, identity: identity });
    }
  }

  leaveRoom = () => {
    this.state.activeRoom.disconnect();
    this.setState({ hasJoinedRoom: false, localMediaAvailable: false });
  }

  attachParticipantTracks = (participant, container) => {
    var tracks = Array.from(participant.tracks.values());
    this.attachTracks(this.getTracks(participant), container);
  }

  attachTracks = (tracks, container) => {
    tracks.forEach( (track) => {
      this.attachTrack(track, container);
    });
  }

  attachTrack = (track, container) => {
    container.appendChild(track.attach());
  }

  getTracks = (participant) => {
    return Array.from(participant.tracks.values()).filter( (publication) => {
      return publication.track;
    }).map( (publication) => {
      return publication.track;
    });
  }

  detachTrack = (track) => {
    track.detach().forEach( (element) => {
      element.remove();
    });
  }

  detachTracks = (tracks) => {
    tracks.forEach(track => {
      track.detach().forEach(detachedElement => {
        detachedElement.remove();
      });
    });
  }

  detachParticipantTracks = (participant) => {
    var tracks = this.getTracks(participant);
    tracks.forEach(this.detachTrack);
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
    videoCallActions: bindActionCreators(
     { ...VideoCallActions }, dispatch )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoCallScreen)
